import animationUrl from '@authFlow/components/AuroraAnimation/animation-aurora.json';

declare global {
  interface Window {
    UnicornStudio?: any;
  }
}

export const initUnicornSdk = (callback: () => void) => {
  if (window.UnicornStudio) {
    callback();
  } else {
    const script = document.createElement('script');
    script.src =
      'https://cdn.jsdelivr.net/gh/hiunicornstudio/unicornstudio.js@v1.4.27/dist/unicornStudio.umd.js';
    script.onload = () => {
      callback();
    };

    document.head.appendChild(script);
  }
};

export const initUnicornScene = (ANIMATION_ID: string) => {
  try {
    const container = document.getElementById(ANIMATION_ID) as HTMLElement;
    window.UnicornStudio.addScene({
      elementId: ANIMATION_ID,
      fps: 60,
      scale: 1,
      dpi: 1,
      lazyLoad: true,
      filePath: animationUrl,
      production: true,
    });

    const onReady = () => {
      if (container) container.setAttribute('data-ready', 'true');
    };
    setTimeout(onReady, 100);
  } catch {}
};
